$(document).ready(function () {

	var gnav03_out = [
		'<div id="gnav03_out">',
		'<ul class="clearfix">',
		'<li id="gnav03_cint" class="gnav03_menu">',
		'<span id="gnav_home_a3"><span>企業インタビュー</span></span>',
		'<div id="gnav_job02_out">',
		'<ul class="pd_list02">',
		'<li><a href="/job/interview/" class="pd_top">注目企業インタビュー</a></li>',
		'<li><a href="/job/it-pro-talk/">ITプロフェッショナル対談</a></li>',
		'</ul>',
		'</div>',
		'</li>',
		'<li id="gnav03_int" class="gnav03_menu">',
		'<span id="gnav_home_a4"><span>転職者インタビュー</span></span>',
		'<div id="gnav_job02_out">',
		'<ul class="pd_list02">',
		'<li><a href="/advantage/interview/" class="pd_top">転職成功者の声</a></li>',
		'<li><a href="/advantage/success/">転職者たちの「今」</a></li>',
		'</ul>',
		'</div>',
		'</li>',
		'<li id="gnav03_knowhow" class="gnav03_menu">',
		'<span id="gnav_home_a5"><span>転職ノウハウ</span></span>',
		'<div id="gnav_job02_out">',
		'<ul class="pd_list02">',
		'<li><a href="/knowhow/careerlab/" class="pd_top">IT業界職種研究</a></li>',
		'<li><a href="/knowhow/column/">コラム：転職の技術</a></li>',
		'<li><a href="/knowhow/rireki/">履歴書フォーム</a></li>',
		'<li><a href="/knowhow/syokureki/">職務経歴書フォーム</a></li>',
		'<li><a href="/knowhow/manual/">転職マニュアル</a></li>',
		'</ul>',
		'</div>',
		'</li>',
		'<li id="gnav03_aboutus" class="gnav03_menu">',
		'<span id="gnav_home_a6"><span>リーべルについて</span></span>',
		'<div id="gnav_job02_out">',
		'<ul class="pd_list02">',
		'<li><a href="/advantage/consultants/" class="pd_top">コンサルタント紹介</a></li>',
		'<li><a href="/advantage/data.html">リーベルの転職実績</a></li>',
		'<li><a href="/advantage/">リーベルの強み</a></li>',
		'<li><a href="/advantage/flow/">無料転職サポートの流れ</a></li>',
		'<li><a href="/start/">転職が初めての方へ</a></li>',
		'</ul>',
		'</div>',
		'</li>',
		'</ul>',
		'</div>'
	].join('');

	$('#wrapper', parent.document).append(gnav03_out);

	$('.gnav03_menu', parent.document).hover(function () {
		var thisId = $(this).attr("id");
		var thisIdOut = '#' + thisId + '_out';
		$(this, '> span').css({
			'background-image': 'none',
			'background-color': '#333'
		});
		$(this).find('.pd_list02', parent.document).show();
	}, function () {
		$(this, '> span').css({
			'background-image': 'url(/common/img/gnav02_bg.png)',
			'background-repeat': 'repeat-x',
			'background-color': '#004263'
		});
		$(this).find('.pd_list02', parent.document).hide();
	});

});
